import { Operator } from '../query'

export type Application = 'gms' | 'support'

export enum Pinned {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT'
}

export enum Direction {
  ASCENDING = 'ASC',
  DESCENDING = 'DESC'
}

export interface ListColumnSetting {
  Name: string
  Index: number
  Width: number
  Pinned: Pinned
  SortIndex: number
  SortDirection: Direction | ''
  FilterOperator: Operator | ''
  FilterValue: string
}

export interface ListSettings {
  Columns: ListColumnSetting[]
  PredefinedSearch: string
}

export interface ListSettingsResponse {
  Data: ListSettings
}

export interface ListParams {
  fields?: string
  orderBy?: string
  page?: number
  perPage?: number
  search?: string
  format?: 'csv' | 'xlsx'
}

export type ListStructure = Record<string, Record<string, string>>

export interface ListDataResponse<T> {
  Data: T[]
  Structure: ListStructure
  Paging: {
    Total: number
  }
}

export type Params = Omit<ListParams, 'format'>

export type LoadSettings = () => Promise<ListSettingsResponse>

export type LoadData<T> = (params: Params) => Promise<ListDataResponse<T>>

export type ExportData = (params: Params) => Promise<Blob>

export type SaveSettings = (data: Partial<ListSettings>) => Promise<void>

export type RestoreDefaultSettings = () => Promise<void>
